/* eslint-disable */
export default {
  unmute: 'Réactiver le micro',
  mute: 'Désactiver le micro',
  keypad: 'Clavier',
  hold: 'Mettre en attente',
  onHold: 'En attente',
  park: 'Parquer',
  stopRecord: 'Arrêter',
  record: 'Enregistrer',
  add: 'Ajouter',
  transfer: 'Transférer',
  flip: 'Basculer',
  more: 'Actions d’appel',
  mergeToConference: 'Fusionner',
  end: 'Terminer',
  completeTransfer: 'Exécuter\nle transfert',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
